import { ADD, ADD_MULTIPLE, UPDATE, REMOVE } from './constants';

export const addAction = (cause) => ({
  type: ADD,
  cause,
});

export const addMultipleAction = (causes) => ({
  type: ADD_MULTIPLE,
  causes,
});

export const updateAction = (cause) => ({
  type: UPDATE,
  cause,
});

export const removeAction = (id) => ({
  type: REMOVE,
  id,
});
